/**
 * Interpreting quote-load (getQuote) failures for display.
 *
 * Warehouse (transload) quotes are discontinued and the backend 404s them on
 * purpose (GET /quotes/{q}/{r}), so any order/lane pointing at one can't load
 * its quote. We surface a clear message instead of a raw "Request failed with
 * status code 404". The backend tags the warehouse 404 with a detail containing
 * "warehouse" so it's distinguishable from a genuine not-found 404.
 */

/** Standardized message for a discontinued warehouse quote (not supported in 360). */
export const WAREHOUSE_QUOTE_MESSAGE = 'Warehouse Quote - Not Implemented in 360';

interface MaybeAxiosError {
  response?: { status?: number; data?: { detail?: unknown } };
}

/** True when a getQuote() failure is the backend's warehouse-quote 404. */
export function isWarehouseQuoteError(err: unknown): boolean {
  const res = (err as MaybeAxiosError | null | undefined)?.response;
  if (res?.status !== 404) return false;
  const detail = res.data?.detail;
  return typeof detail === 'string' && /warehouse/i.test(detail);
}
